import imageService from './imageService';

// Asset Service - Local priority in dev, S3 priority in production
class AssetService {
  constructor() {
    this.s3Assets = null;
    this.s3Loaded = false;
    this.s3LoadError = false;
  }

  // Load all assets from S3 database
  async loadS3Assets() {
    if (this.s3Loaded) {
      return this.s3Assets;
    }

    try {
      console.log('🌐 AssetService: Loading S3 assets...');
      const result = await imageService.getAllImages();
      
      if (result.success && result.data) {
        this.s3Assets = result.data;
        this.s3Loaded = true;
        this.s3LoadError = false;
        console.log('✅ AssetService: S3 assets loaded successfully');
        console.log('📦 S3 Assets count:', this.s3Assets.length);
        return this.s3Assets;
      } else {
        throw new Error('Failed to load S3 assets');
      }
    } catch (error) {
      console.error('❌ AssetService: Failed to load S3 assets:', error);
      this.s3LoadError = true;
      this.s3Assets = [];
      return [];
    }
  }

  // Get asset URL - always prefer backend/S3 asset when available.
  getAssetUrl(assetName, localFallbackPath) {
    // Check if assetName is valid
    if (!assetName || typeof assetName !== 'string') {
      console.log(`❌ AssetService: Invalid asset name:`, assetName);
      return localFallbackPath || null;
    }

    // Try to find in S3/production assets
    if (this.s3Assets && this.s3Assets.length > 0) {
      const s3Asset = this.s3Assets.find(asset => {
        if (!asset || !asset.original_name || typeof asset.original_name !== 'string') {
          return false;
        }
        return asset.original_name.toLowerCase() === assetName.toLowerCase();
      });
      
      const resolved = s3Asset && (s3Asset.url || s3Asset.s3_url);
      if (resolved) {
        console.log(`✅ AssetService: Found ${assetName}:`, resolved);
        return resolved;
      }
    }

    // Fallback to local asset
    if (localFallbackPath) {
      console.log(`🔄 AssetService: Using local fallback for ${assetName}:`, localFallbackPath);
      return localFallbackPath;
    }

    console.log(`❌ AssetService: No asset found for ${assetName}`);
    return null;
  }

  // Get multiple asset URLs
  getAssetUrls(assetMap) {
    const urls = {};
    for (const [assetName, localPath] of Object.entries(assetMap)) {
      const url = this.getAssetUrl(assetName, localPath);
      if (url) {
        urls[assetName] = url;
      }
    }
    return urls;
  }

  // Check if S3 is available
  isS3Available() {
    return this.s3Loaded && !this.s3LoadError && this.s3Assets && this.s3Assets.length > 0;
  }

  // Get S3 asset by name
  getS3Asset(assetName) {
    if (!this.s3Assets || !assetName || typeof assetName !== 'string') return null;
    
    return this.s3Assets.find(asset => {
      if (!asset || !asset.original_name || typeof asset.original_name !== 'string') {
        return false;
      }
      return asset.original_name.toLowerCase() === assetName.toLowerCase();
    });
  }

  // Get all S3 assets
  getAllS3Assets() {
    return this.s3Assets || [];
  }
}

export default new AssetService(); 